module.exports = __webpack_public_path__ + "static/media/GifTastic.d1886a0c.png";